module.exports = __webpack_public_path__ + "img/26.099ece73.png";